module.exports = "/assets/src/assets/parfumImage.jpg";